import Vue from 'vue'
import {
  URL_USERS,
  URL_USERS_RESET_CONFIRM_EMAIL
} from '@/constants/urls.js'
import { USER_TYPES, SUBSCRIPTION_TYPES } from '@/constants/business.js'
import { USER_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [USER_MANAGEMENT.STATE.USERS]: {
    registered: null,
    unregistered: null
  },
  [USER_MANAGEMENT.STATE.CURRENT_USER]: null,
  [USER_MANAGEMENT.STATE.NEW_USER]: {
    login: null,
    password: null,
    passwordConfirmation: null,
    email: null,
    phone: null,
    contactPerson: null,
    fileId: null,
    organizationId: null,
    dateBegin: null,
    dateEnd: null,
    subscriptionsStatus: SUBSCRIPTION_TYPES.FULL
  },
  [USER_MANAGEMENT.STATE.USER_CHANGED]: true,
  [USER_MANAGEMENT.STATE.AUTHORIZATION_DOCUMENTS]: null,
  [USER_MANAGEMENT.STATE.SUBSCRIPTIONS]: null,
  [USER_MANAGEMENT.STATE.ORGANIZERS]: null,
  [USER_MANAGEMENT.STATE.USER_EXPIRATION_DATES]: null
}

const actions = {
  async [USER_MANAGEMENT.ACTIONS.MERGE_FIELDS] ({ commit }, user) {
    commit(USER_MANAGEMENT.MUTATIONS.MERGE_FIELDS, user)
    commit(USER_MANAGEMENT.MUTATIONS.USER_CHANGED, true)
  },
  async [USER_MANAGEMENT.ACTIONS.CREATE_USER] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}`,
      model
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.MERGE_FIELDS, resp.data)
    commit(USER_MANAGEMENT.MUTATIONS.USER_CHANGED, false)
  },
  // async [USER_MANAGEMENT.ACTIONS.FINISH_USER_REGISTRATION] ({ dispatch, commit }, model) {
  //   model = {
  //     url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/request`,
  //     model: model.files
  //   }
  //   await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
  //   commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  // },
  async [USER_MANAGEMENT.ACTIONS.GET_USERS_LIST] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USERS_LIST, {
      users: resp.data,
      status: params.isRegistered
        ? USER_TYPES.REGISTERED
        : USER_TYPES.UNREGISTERED
    })
  },
  async [USER_MANAGEMENT.ACTIONS.GET_ALL_ORGANIZERS] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/organizers?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    // commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_ALL_ORGANIZERS, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.GET_AUTHORIZATION_DOCUMENTS_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/authorizationDocuments?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_AUTHORIZATION_DOCUMENTS_ADMIN, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.GET_USER_FOR_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USER_FOR_ADMIN, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.GET_EXPIRATION_DATES] ({ commit, dispatch }, userId) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${userId}/expirationDates?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_EXPIRATION_DATES, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.CHANGE_USER_LOCK_STATUS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/lockStatus`,
      model: { isLocked: model.isLocked }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.GET_USER_SUBSCRIPTION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/subscriptions?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USER_SUBSCRIPTION, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.CHANGE_USER_SUBSCRIPTION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/subscriptions`,
      model: model.subscriptions
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USER_SUBSCRIPTION, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.UPDATE_USER] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}`,
      model: model.profile
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USER_FOR_ADMIN, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.UPDATE_USER_EMAIL] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/email`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.UPDATE_EXPIRATION_DATE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/statementExpirationDate`,
      model: { expirationDate: model.expirationDate }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.CREATE_AUTHORIZATION_DOCUMENT_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/authorizationDocuments`,
      model: model.authorizationDocument
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.RESET_CONFIRM_EMAIL] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS_RESET_CONFIRM_EMAIL}/${model.userId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_NEW_USER] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_NEW_USER)
    commit(USER_MANAGEMENT.MUTATIONS.USER_CHANGED, true)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_USER_FOR_ADMIN] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_USER_FOR_ADMIN)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_ALL_ORGANIZERS] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_ALL_ORGANIZERS)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_USER_SUBSCRIPTION] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_USER_SUBSCRIPTION)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_USERS_LIST] ({ commit }, status) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_USERS_LIST, status)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_AUTHORIZATION_DOCUMENTS_ADMIN] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_AUTHORIZATION_DOCUMENTS_ADMIN)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_EXPIRATION_DATES] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_EXPIRATION_DATES)
  }
}

const mutations = {
  [USER_MANAGEMENT.MUTATIONS.USER_CHANGED] (state, flag) {
    state[USER_MANAGEMENT.STATE.USER_CHANGED] = flag
  },
  [USER_MANAGEMENT.MUTATIONS.MERGE_FIELDS] (state, editedFieldsObj) {
    for (const key in editedFieldsObj) {
      Vue.set(state[USER_MANAGEMENT.STATE.NEW_USER], key, editedFieldsObj[key])
    }
  },
  [USER_MANAGEMENT.MUTATIONS.GET_USERS_LIST] (state, model) {
    state[USER_MANAGEMENT.STATE.USERS][model.status] = model.users
  },
  [USER_MANAGEMENT.MUTATIONS.GET_ALL_ORGANIZERS] (state, users) {
    state[USER_MANAGEMENT.STATE.ORGANIZERS] = users
  },
  [USER_MANAGEMENT.MUTATIONS.GET_AUTHORIZATION_DOCUMENTS_ADMIN] (state, authorizationDocuments) {
    state[USER_MANAGEMENT.STATE.AUTHORIZATION_DOCUMENTS] = authorizationDocuments
  },
  [USER_MANAGEMENT.MUTATIONS.GET_USER_FOR_ADMIN] (state, user) {
    state[USER_MANAGEMENT.STATE.CURRENT_USER] = user
  },
  [USER_MANAGEMENT.MUTATIONS.GET_EXPIRATION_DATES] (state, model) {
    state[USER_MANAGEMENT.STATE.USER_EXPIRATION_DATES] = model
  },
  [USER_MANAGEMENT.MUTATIONS.GET_USER_SUBSCRIPTION] (state, subscriptions) {
    state[USER_MANAGEMENT.STATE.SUBSCRIPTIONS] = subscriptions
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_NEW_USER] (state) {
    for (const key in state[USER_MANAGEMENT.STATE.NEW_USER]) {
      state[USER_MANAGEMENT.STATE.NEW_USER][key] = key === 'subscriptionsStatus'
        ? SUBSCRIPTION_TYPES.FULL
        : null
    }
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_USER_SUBSCRIPTION] (state) {
    state[USER_MANAGEMENT.STATE.SUBSCRIPTIONS] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_USER_FOR_ADMIN] (state) {
    state[USER_MANAGEMENT.STATE.CURRENT_USER] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_EXPIRATION_DATES] (state) {
    state[USER_MANAGEMENT.STATE.USER_EXPIRATION_DATES] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_ALL_ORGANIZERS] (state) {
    state[USER_MANAGEMENT.STATE.ORGANIZERS] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_USERS_LIST] (state, status) {
    state[USER_MANAGEMENT.STATE.USERS][status] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_AUTHORIZATION_DOCUMENTS_ADMIN] (state) {
    state[USER_MANAGEMENT.STATE.AUTHORIZATION_DOCUMENTS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
